import { useEffect, useState } from 'react'
import isEqual from 'lodash/isEqual'
import isObject from 'lodash/isObject'
import isEmpty from 'lodash/isEmpty'

import PortalModal, { usePortalModal } from 'components/commons/PortalModal'
import ErrorModal from '../ErrorModal'

import { useStateValue } from 'context/store'
import { putToApi } from 'actions'
import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'
import {
   PUBLISH_PROGRAMMED_QUEST_CONFIRMATION_QUESTION,
   QUESTIONNAIRE
} from '../../constants'
import { publishQuestAction } from 'context/reducers/QuestionariesReducer'
import { reactSwitch } from 'utils/utils'

const publishMessageFn = rowData => {
   if (rowData?.message) return rowData.message
   return reactSwitch(rowData?.status, {
      [QUESTIONNAIRE.INACTIVE_STATUS]:
         'Señor usuario, está intentando publicar un cuestionario en estado inactivo. ¿Desea activarlo y realizar la publicación de este cuestionario?',
      [QUESTIONNAIRE.PROGRAMMED_STATUS]:
         PUBLISH_PROGRAMMED_QUEST_CONFIRMATION_QUESTION,
      default:
         'Señor usuario, ¿Está seguro que desea realizar la publicación de este cuestionario?'
   })
}

const PublishQuestionnaire = () => {
   const { params, onClose, setModal } = usePortalModal()
   const [errorMessage, setErrorMessage] = useState()
   const [{ questionaries = {} }, dispatch] = useStateValue()

   const handlePublish = async rowData => {
      const openMessage = async resp => {
         // if (rowData?.initialDate) {
         //    return dispatch(
         //       openSnackBarAction(
         //          `El Cuestionario ${rowData.name} Se publicara en ${rowData.initialDate}`,
         //          'success'
         //       )
         //    )
         // }
         dispatch(openSnackBarAction(resp?.message, 'success'))
      }
      const validateQuestUrl = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/validate?questionareId=${rowData?.id}`
      if (!rowData?.id) {
         dispatch(openSnackBarAction('Cuestionario indice nulo', 'error'))
         return
      }

      if (rowData?.isChange) {
         const ahora = new Date()
         const anio = ahora.getFullYear()
         const mes = (ahora.getMonth() + 1).toString().padStart(2, '0')
         const dia = ahora.getDate().toString().padStart(2, '0')
         const hora = ahora.getHours().toString().padStart(2, '0')
         const minutos = ahora.getMinutes().toString().padStart(2, '0')
         const fechaHoraColombia = `${anio}-${mes}-${dia}T${hora}:${minutos}`
         const reverseStringDate = stringDate => {
            const splittedDate = stringDate?.split('-')
            const shouldReverse = splittedDate?.[0]?.length == 2
            return shouldReverse ? splittedDate.reverse().join('-') : stringDate
         }

         const payload = {
            initialDate: fechaHoraColombia,
            status: rowData?.statusChange,
            finalDate: reverseStringDate(rowData?.finalDate)
         }
         const URL_QUESTIONNARIE = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/${rowData.id}`
         try {
            const dataPost = await putToApi(URL_QUESTIONNARIE, payload)
            openMessage(dataPost)
            return
         } catch (error) {
            return dispatch(openSnackBarAction(error?.data?.message))
         }
      }

      await putToApi(validateQuestUrl)
         .then(resp => {
            dispatch(publishQuestAction(QUESTIONNAIRE.PUBLISHED_STATUS))
            openMessage(resp)
         })

         .catch(err => {
            const { errors, message } = err?.data || {}
            clearPublishState()
            if (errors || message) {
               setErrorMessage(isEmpty(errors) ? [message] : errors)
            } else {
               dispatch(openSnackBarAction('Error de comunicación', 'error'))
            }
         })
   }

   const showPublishConfirmationModal = rowData => {
      if (isEqual(rowData?.status, QUESTIONNAIRE.PUBLISHED_STATUS)) {
         clearPublishState()
         return dispatch(
            openSnackBarAction(
               'Este cuestionario ya se encuentra publicado',
               'info'
            )
         )
      }
      const publishMessage = publishMessageFn(rowData)
      setModal({
         message: publishMessage,
         onConfirm: handlePublish,
         value: rowData
      })
   }

   const clearPublishState = () => dispatch(publishQuestAction())

   const handleClose = () => {
      clearPublishState()
      onClose()
   }

   useEffect(() => {
      const publishState = questionaries?.publishState
      isObject(publishState) && showPublishConfirmationModal(publishState)
      isEqual(publishState, QUESTIONNAIRE.PUBLISHED_STATUS) &&
         clearPublishState()
   }, [questionaries])

   return (
      <>
         <PortalModal params={params} onClose={handleClose} />
         <ErrorModal
            showComfirmationModal={Boolean(errorMessage)}
            setShowComfirmationModal={setErrorMessage}
            errors={errorMessage || null}
         />
      </>
   )
}

export default PublishQuestionnaire
